/* global axios */
import ApiClient from './ApiClient';

class InboxTemplatePermissionsAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/template_permissions`);
  }

  update(inboxId, templateNames) {
    return axios.patch(`${this.url}/${inboxId}/template_permissions`, {
      template_names: templateNames,
    });
  }
}

export default new InboxTemplatePermissionsAPI();
